import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itemSelection',
  pure: false
})
export class ItemSelectionPipe implements PipeTransform {

  public transform(list: number[], id: number, isSelectAll: boolean | null): boolean {
    if (isSelectAll == true) {
      //List contains items that are deselected
      return list?.find(x => x == id) == null;
    } else {
      //List contains items that are selected
      return list?.find(x => x == id) != null;
    }
    
  }

}
